import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-dxjc",
  "use": "icon-dxjc-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 16\" id=\"icon-dxjc\">\n<g>\n\t<polygon points=\"12.539,6.242 14.726,14.605 6.39,12.317 \t\" />\n\t\n\t\t<rect x=\"5.347\" y=\"1.246\" transform=\"matrix(-0.7116 0.7025 -0.7025 -0.7116 15.7336 6.2638)\" width=\"2.468\" height=\"10.229\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol